import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import { SadieBreakdownRow } from "@/components/tools/sadie-dashboard/SadieBreakdownRow";
import { SadieStatDelta } from "@/components/tools/sadie-dashboard/SadieStatDelta";
import { Card } from "@ui/card";

import {
  SadieDashboardRange,
  SadieDashboardReferrals,
  SadieStatFormat,
} from "@/types";

// People workers pointed Sadie at, and what became of them. Someone Sadie
// already had a relationship with is never recorded, so never counted.
export const SadieReferralsCard = ({
  range,
  referrals,
}: {
  range: SadieDashboardRange;
  referrals: SadieDashboardReferrals;
}) => {
  /* Helpers */
  const referrerCount = referrals.referrers.value;

  /* Render */
  return (
    <Card className="p-5">
      <Column className="gap-3">
        <Column className="gap-0.5">
          <Text className="font-plex-mono text-[9px] font-medium uppercase tracking-wider text-slate-500">
            Relationships
          </Text>
          <Text className="text-sm font-semibold text-slate-900">
            Referrals
          </Text>
        </Column>
        <Row className="items-baseline gap-2">
          <Text className="text-3xl font-semibold text-slate-900">
            {referrals.total.value.toLocaleString()}
          </Text>
          <Text className="text-xs font-normal text-slate-500">
            from {referrerCount.toLocaleString()}{" "}
            {referrerCount === 1 ? "worker" : "workers"}
          </Text>
        </Row>
        <SadieStatDelta
          format={SadieStatFormat.COUNT}
          range={range}
          stat={referrals.total}
        />
        <Column className="gap-1.5 border-t border-slate-100 pt-3">
          <SadieBreakdownRow
            count={referrals.alreadyOnLaborup.value}
            label="Already on Laborup"
          />
          <SadieBreakdownRow
            count={referrals.newToLaborup.value}
            label="New to Laborup"
          />
          <SadieBreakdownRow
            count={referrals.couldNotAdd.value}
            label="Couldn't be added"
          />
          {referrals.unclassified.value > 0 ? (
            <SadieBreakdownRow
              count={referrals.unclassified.value}
              label="Recorded before tracking"
            />
          ) : null}
        </Column>
      </Column>
    </Card>
  );
};
